import { createDocument, getAllData, updateDocumentByID } from 'apis/customApiHandler';
import AddTrainingMateraial from '../components/training-materials/addTrainingMaterial';
import ViewTrainingMaterialList from '../components/training-materials/viewTrainingMaterial';
import Add from "../components/dtp-points/Add"
import Edit from "../components/dtp-points/Edit"
import Delete from "../components/dtp-points/Delete"
import useDebounce from 'hooks/useDebounce';
import { useEffect, useRef, useState } from 'react';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { Button, Input, Select } from 'styled';
import { TD, TH } from 'styled/table';
import checkPermission from 'utils/checkPermission';
import permissions from 'utils/permissionConstants';
import { FaEdit, FaEye, FaTrash } from 'react-icons/fa';
import {MdOutlineDragIndicator} from 'react-icons/md';
import toast from 'react-hot-toast';
import Spinner from 'components/Spinner';

const DTPDiscussionPoints = () => {
  const [showAddmodel, setShowAddmodel] = useState(false);
  const [search, setSearch] = useState('');
  const currentUser = useSelector((state) => state.user.currentUser);
  const [showViewModel, setShowViewModel] = useState(false);
  const [showEditModel, setShowEditModel] = useState(false);
  const [showDeleteModel, setShowDeleteModel] = useState(false);
  const [data, setData] = useState({})
  const [active, setActive] = useState("")
  const [dragging, setDragging] = useState(false);
  const [loading, setLoading] = useState(false);
  const debouncedValue = useDebounce(search, 1000);
  const [list, setList] = useState([])

  const getData= async()=>{
    setLoading(true)
    try{
      const data = await getAllData('/dtpDiscussionPoints', { searchQuery: search, active: active === "" ? "all" : active })
      setList(data?.data)
    }catch(err){
      toast.error(err.messagee ?? "Some Error Occured")
    }
    setLoading(false);

  }
  useEffect(()=>{
    getData();
  }, [search, active])

  const drag = async(start, end)=>{
    setDragging(true);
    try{
    const response = await createDocument("/dtpDiscussionPoints/drag", {start, end})
    if(response?.message) toast.success(response?.message)
    await getData();
    }catch(err){
      console.log({err})
    }
    setDragging(false)
  }

  const dragItem = useRef();
  const dragOverItem = useRef();
 
  const dragStart = (e, position) => {
    dragItem.current = position;
    console.log("Start", position)
  };
 
  const dragEnter = (e, position) => {
    dragOverItem.current = position;
    console.log("Enter", position)
  };
 
  const drop = async (e, index) => {
    const copyListItems = [...list];
    const dragItemContent = copyListItems[dragItem.current];
    console.log("currentIndex", dragOverItem.current)
    // copyListItems.splice(dragItem.current, 1);
    // copyListItems.splice(dragOverItem.current, 0, dragItemContent);

    //drag dragOverItem and dragItem indexes using current
    // console.log(copyListItems, index)
    await drag(dragItem.current, dragOverItem.current)
    
    dragItem.current = null;
    dragOverItem.current = null;
    // updateDocumentByID("/training-materials",)
    // setList(copyListItems);
  };

  return (
    <div>
      <div className="m-10">
        <div className="mt-8 flex justify-start gap-6 items-end flex-wrap lg:flex-nowrap">
          <div className="relative w-full">
            <label className="w-full py-3 flex flex-col gap-2">
              Search
            <Input
              type="search"
              placeholder="Search Here"
              onChange={(e) => {
                setSearch(e.target.value);
              }}
            />
            </label>
          </div>
          <div className="relative w-full max-w-[14rem]">
          <label className="w-full py-3 flex flex-col gap-2">
            Active
            <Select
              name="active"
              value={active}
              onChange={(e) => setActive(e.target.value)}
            >
              <option value={""}>All</option>
              <option value={true}>Active</option>
              <option value={false}>Inactive</option>
            </Select>
          </label>
          </div>
          <Button
            className="mb-3 !px-8 disabled:bg-gray-400"
            bgPrimary
            onClick={() => setShowAddmodel(true)}
            disabled={
              !checkPermission([permissions.create_dtp_points], currentUser)
            }
          >
            Add
          </Button>
        </div>
      </div>
      {loading ? (
        <div className="w-full items-center">
          <Spinner />
        </div>
      ) : (
        <div className="flex flex-col m-2 lg:m-10">
          <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <TH scope="col"></TH>
                      <TH scope="col">S.N.</TH>
                      <TH scope="col">Discussion Point</TH>
                      <TH scope="col">Date</TH>
                      <TH scope="col">Added By</TH>
                      <TH scope="col">Active</TH>
                      <TH scope="col">Actions</TH>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {list &&
                      list.map((item, index) => (
                        <tr
                          className="hover:shadow-md"
                          style={{ margin: "20px 25%", textAlign: "center" }}
                          onDragStart={(e) => dragStart(e, item.index)}
                          onDragEnter={(e) => dragEnter(e, item.index)}
                          onDragEnd={(e) => {
                            drop(e, item.index);
                          }}
                          key={item.index}
                          draggable={!dragging}
                        >
                          <TD className="text-left text-lg">
                            <MdOutlineDragIndicator
                              style={{ fontSize: "18px" }}
                            />
                          </TD>
                          <TD className="text-left">{index + 1}</TD>
                          <TD
                            className="text-left break-words"
                            style={{
                              maxWidth: "200px",
                              overflow: "hidden",
                              whiteSpace: "normal",
                            }}
                          >
                            {item.description}
                          </TD>
                          <TD className="text-left">
                            {item?.createdAt
                              ? new Date(item?.createdAt).toLocaleDateString(
                                  "en-GB"
                                ).replace(/\//g, '-')
                              : "-----"}
                          </TD>
                          <TD className="text-left">{item?.createdBy?.name}</TD>
                          <TD
                            className={`text-left ${
                              item.active ? " text-green-600" : "text-red-500"
                            }`}
                          >
                            {item.active ? "Yes" : "No"}
                          </TD>
                          <TD className="text-left flex flex-row">
                            {checkPermission(
                              [permissions.edit_dtp_points],
                              currentUser
                            ) ? (
                              <div className="">
                                <button
                                  onClick={() => {
                                    setData(item);
                                    setShowEditModel(true);
                                  }}
                                  className="p-2 m-1  rounded-md bg-green-500 hover:bg-green-600 text-white"
                                >
                                  <FaEdit />
                                </button>
                              </div>
                            ) : (
                              <p>----</p>
                            )}
                            {checkPermission(
                              [permissions.delete_dtp_points],
                              currentUser
                            ) ? (
                              <button
                                onClick={() => {
                                  setData(item);
                                  setShowDeleteModel(true);
                                }}
                                className="p-2  m-1 rounded-md bg-red-500 hover:bg-red-600 text-white"
                              >
                                <FaTrash />
                              </button>
                            ) : (
                              <p>----</p>
                            )}
                          </TD>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
      {showAddmodel && (
        <Add
          handleClick={async () => {
            setShowAddmodel(false);
            await getData();
          }}
        />
      )}
      {showDeleteModel && (
        <Delete
          data={data}
          handleClick={async () => {
            setShowDeleteModel(false);
            await getData();
          }}
        />
      )}
      {showEditModel && (
        <Edit
          data={data}
          handleClick={async () => {
            setShowEditModel(false);
            await getData();
          }}
        />
      )}
    </div>
  );
};

export default DTPDiscussionPoints;
